import React from 'react'
import { Faq } from 'screens/faq'

const FaqPage = () => <Faq />

export default FaqPage
